import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "orbis_session";

export const session = {
  get: () => JSON.parse(localStorage.getItem(KEY) || "null"),
  set: (s) => localStorage.setItem(KEY, JSON.stringify(s)),
  clear: () => localStorage.removeItem(KEY),
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const s = session.get();
  if (s?.access_token) cfg.headers.Authorization = `Bearer ${s.access_token}`;
  if (["post", "put", "patch", "delete"].includes((cfg.method || "").toLowerCase()) && !cfg.headers["X-Request-Id"]) cfg.headers["X-Request-Id"] = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => {
    if (r.status === 202 && r.data?.queued_offline) { window.dispatchEvent(new CustomEvent("orbis-queued-offline", { detail: r.config?.url })); window.__orbisQueuedAt = Date.now(); }
    if (r.headers?.["x-offline-cache"]) window.dispatchEvent(new CustomEvent("orbis-served-offline"));
    return r;
  },
  async (err) => {
    const orig = err.config || {};
    const s = session.get();
    const skip = ["/auth/refresh", "/login", "/mfa/"].some((u) => (orig.url || "").includes(u));
    if (err.response?.status === 401 && !orig._retry && s?.refresh_token && !skip) {
      orig._retry = true;
      try {
        const { data } = await axios.post(`${API}/auth/refresh`, { refresh_token: s.refresh_token });
        session.set({ ...s, ...data });
        orig.headers.Authorization = `Bearer ${data.access_token}`;
        return api(orig);
      } catch (e) {
        session.clear();
        window.location.href = s.scope === "platform" ? "/platform-admin/login" : "/login";
      }
    }
    return Promise.reject(err);
  }
);

export async function downloadFile(path, filename, client = api) {
  const { data } = await client.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = Object.assign(document.createElement("a"), { href: url, download: filename });
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") {
    if (d.startsWith("too_many_attempts")) { const s = +d.split(":")[1] || 0; return `Too many attempts — try again in ${Math.max(1, Math.ceil(s / 60))} min`; }
    if (d.startsWith("weak_password")) return `Password too weak: ${(d.split(":")[1] || "").replace(/_/g, " ")}`;
    if (d.startsWith("open_invoices")) return `Cannot erase: ${d.split(":")[1]} open invoice(s) must be settled or cancelled first`;
    if (d === "session_revoked") return "This session was signed out on another device";
    return d.replace(/_/g, " ");
  }
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(", ");
  return d.msg || String(d);
}
